export default __webpack_public_path__ + "media/color/sol-8cb1b5ca.svg";